import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from 'react-router-dom';

import Home from './pages/Home/Home';
import Blog from './pages/Blog/Blog';
import BlogList from './pages/BlogList/BlogList';
import BlogDetail from './pages/Blog/BlogDetail';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Admin from './pages/Admin/Admin';
import AdminBlogList from './pages/Admin/BlogList';

function AppContent() {
  const location = useLocation();

  // Hide footer only on /blog/:slug
  const hideFooter = /^\/blog\/[^/]+$/.test(location.pathname);

  return (
    <div className="bg-slate-950 min-h-screen text-slate-100 selection:bg-indigo-500 selection:text-white flex flex-col justify-between">

      {/* PREMIUM SHARED GLOBAL NAVIGATION BAR */}
      <nav className="border-b border-slate-900 bg-slate-950/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            className="text-xl font-black tracking-tight text-white hover:opacity-90 transition-opacity"
          >
            MoreView<span className="text-indigo-500">.in</span>
          </Link>

          <div className="flex items-center gap-6 text-sm font-semibold text-slate-400">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <Link to="/blogs" className="hover:text-white transition-colors">
              Journal
            </Link>
            <Link to="/about" className="hover:text-white transition-colors">
              About
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </nav>

      {/* ROUTES */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
			<Route path="/admin/edit/:id" element={<Admin />} />	
          <Route path="/admin/blogs" element={<AdminBlogList />} />
        </Routes>
      </main>

      {/* FOOTER */}
      {!hideFooter && (
        <footer className="bg-slate-900 text-slate-400 py-10 border-t border-slate-950 relative z-10 mt-auto">
          <div className="max-w-screen-2xl mx-auto px-6 sm:px-12 lg:px-24 flex flex-col sm:flex-row justify-between items-center gap-6">
            <div className="text-sm font-medium text-center sm:text-left">
              <span className="text-white font-bold">MoreView.in</span> ©{' '}
              {new Date().getFullYear()} — Engineering Premium Content Delivery.
            </div>

            <div className="flex gap-6 text-xs font-mono text-slate-500">
              <span>
                Node Engine Status:{' '}
                <span className="text-emerald-400 font-bold">ONLINE</span>
              </span>
              <span>Cluster: Active</span>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
